module.exports = __webpack_public_path__ + "static/media/ff-dollyrots.cc93aedb.png";